import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import studioImage01 from "../assets/studio-images/studio-image01.jpg";
import studioImage02 from "../assets/studio-images/studio-image02.jpg";
import studioImage03 from "../assets/studio-images/studio-image03.jpg";
import studioImage04 from "../assets/studio-images/studio-image04.jpg";
import studioImage05 from "../assets/studio-images/studio-image05.jpg";
import studioImage06 from "../assets/studio-images/studio-image06.jpg";
import studioImage07 from "../assets/studio-images/studio-image07.jpg";
import studioImage08 from "../assets/studio-images/studio-image08.jpg";
import studioImage09 from "../assets/studio-images/studio-image09.jpg";
import studioImage10 from "../assets/studio-images/studio-image10.jpg";
import studioImage11 from "../assets/studio-images/studio-image11.jpg";
import studioImage12 from "../assets/studio-images/studio-image12.jpg";
import studioImage13 from "../assets/studio-images/studio-image13.jpg";
import studioImage14 from "../assets/studio-images/studio-image14.jpg";
import studioImage15 from "../assets/studio-images/studio-image15.jpg";
import studioImage16 from "../assets/studio-images/studio-image16.jpg";
import studioImage17 from "../assets/studio-images/studio-image17.jpg";
import studioImage18 from "../assets/studio-images/studio-image18.jpg";
import studioImage19 from "../assets/studio-images/studio-image19.jpg";
import studioImage20 from "../assets/studio-images/studio-image20.jpg";
import studioImage21 from "../assets/studio-images/studio-image21.jpg";
import studioImage22 from "../assets/studio-images/studio-image22.jpg";
import studioImage23 from "../assets/studio-images/studio-image23.jpg";
import studioImage24 from "../assets/studio-images/studio-image24.jpg";
import studioImage25 from "../assets/studio-images/studio-image25.jpg";
import studioImage26 from "../assets/studio-images/studio-image26.jpg";
import studioImage27 from "../assets/studio-images/studio-image27.jpg";
import studioImage28 from "../assets/studio-images/studio-image28.jpg";
import studioImage29 from "../assets/studio-images/studio-image29.jpg";
import studioImage30 from "../assets/studio-images/studio-image30.jpg";
import studioImage31 from "../assets/studio-images/studio-image31.jpg";
import studioImage32 from "../assets/studio-images/studio-image32.jpg";
import studioImage33 from "../assets/studio-images/studio-image33.jpg";
import studioImage34 from "../assets/studio-images/studio-image34.jpg";
import studioImage35 from "../assets/studio-images/studio-image35.jpg";
import studioImage36 from "../assets/studio-images/studio-image36.jpg";
import studioImage37 from "../assets/studio-images/studio-image37.jpg";
import studioImage38 from "../assets/studio-images/studio-image38.jpg";
import studioImage39 from "../assets/studio-images/studio-image39.jpg";
import studioImage40 from "../assets/studio-images/studio-image40.jpg";
import studioImage41 from "../assets/studio-images/studio-image41.jpg";

const ALL_STUDIO_IMAGES = [
  studioImage01,
  studioImage02,
  studioImage03,
  studioImage04,
  studioImage05,
  studioImage06,
  studioImage07,
  studioImage08,
  studioImage09,
  studioImage10,
  studioImage11,
  studioImage12,
  studioImage13,
  studioImage14,
  studioImage15,
  studioImage16,
  studioImage17,
  studioImage18,
  studioImage19,
  studioImage20,
  studioImage21,
  studioImage22,
  studioImage23,
  studioImage24,
  studioImage25,
  studioImage26,
  studioImage27,
  studioImage28,
  studioImage29,
  studioImage30,
  studioImage31,
  studioImage32,
  studioImage33,
  studioImage34,
  studioImage35,
  studioImage36,
  studioImage37,
  studioImage38,
  studioImage39,
  studioImage40,
  studioImage41,
];

const shuffleArray = (array) => {
  const shuffled = [...array];

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
};

const getVisibleCount = (width) => {
  if (width >= 1280) return 4;
  if (width >= 1024) return 3;
  if (width >= 640) return 2;
  return 1;
};

export default function StudioGalleryCarousel() {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(() =>
    typeof window !== "undefined" ? getVisibleCount(window.innerWidth) : 4,
  );

  useEffect(() => {
    setImages(shuffleArray(ALL_STUDIO_IMAGES));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount(window.innerWidth));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalSlides = useMemo(() => {
    if (!images.length) return 0;
    return Math.max(images.length - visibleCount + 1, 1);
  }, [images, visibleCount]);

  useEffect(() => {
    if (currentIndex > totalSlides - 1) {
      setCurrentIndex(0);
    }
  }, [currentIndex, totalSlides]);

  useEffect(() => {
    if (totalSlides <= 1) return undefined;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 3000);

    return () => clearInterval(interval);
  }, [totalSlides]);

  const translatePercentage = 100 / visibleCount;

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  if (!images.length) return null;

  return (
    <section className="border-b border-white/10 bg-[#0b0b0c]">
      <div className="mx-auto max-w-7xl px-5 py-16">
        <div className="mb-8 text-center">
          <p className="text-sm uppercase tracking-[0.25em] text-pink-400/80">
            Gallery
          </p>
          <h2 className="mt-2 text-3xl font-semibold">
            Moments captured in our studio
          </h2>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-[2rem]">
            <div
              className="flex transition-transform duration-700 ease-out"
              style={{
                transform: `translateX(-${currentIndex * translatePercentage}%)`,
              }}
            >
              {images.map((img, index) => (
                <div
                  key={`${img}-${index}`}
                  className="shrink-0 px-2"
                  style={{ width: `${100 / visibleCount}%` }}
                >
                  <div className="group relative overflow-hidden rounded-[1.75rem] border border-white/10 bg-white/[0.03]">
                    <div className="aspect-[4/5] w-full overflow-hidden bg-black">
                      <img
                        src={img}
                        alt={`Studio session ${index + 1}`}
                        className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>

                    <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent opacity-80" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {totalSlides > 1 && (
            <>
              <button
                type="button"
                onClick={goToPrev}
                aria-label="Previous images"
                className="absolute left-0 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-black/45 text-white backdrop-blur transition hover:bg-black/65"
              >
                ‹
              </button>

              <button
                type="button"
                onClick={goToNext}
                aria-label="Next images"
                className="absolute right-0 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-black/45 text-white backdrop-blur transition hover:bg-black/65"
              >
                ›
              </button>
            </>
          )}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/gallery"
            className="inline-flex items-center rounded-2xl bg-pink-500 px-6 py-3 text-sm font-semibold text-white transition hover:bg-pink-400"
          >
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>
  );
}
